import React from 'react';
import { useRouteError } from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import PermissionDeniedPage from './PermissionDeniedPage';

export default function ErrorPage() {
  const error = useRouteError();
  if (error.status === 404) {
    return <NotFoundPage />;
  }
  if (error.status === 403) {
    return <PermissionDeniedPage />;
  }
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
